"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getNextUniqueId;
var nextUniqueId = 0;

function getNextUniqueId() {
  return nextUniqueId++;
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/utils/getNextUniqueId.js
// module id = 904
// module chunks = 1